import coctel from "./coctel.png";
import recepcion from "./recepcion.png";

const obj = {
  coctel,
  recepcion,
};

export default obj;
